<div class="confirmPurchaseWrap section">
    <div class="gameHeader subHeader">
        <button class="back leftbtn" (click)="closeTicket()">
            <svg class="svgicon">
                <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
            </svg>
        </button>
        <div class="pageIndicator">
            <div class="title">{{'dge.purchase_det' | translate}}</div>
            <div class="userinfo">
                <div class="userName">{{userInfo?.playername}}</div>
                <div class="balanceWrap" innerHTML="{{userInfo?.balance | custCurrency}}"></div>
            </div>
        </div>
    </div>
    <div class="purcahseDetailWrap">
        <div class="sectionWrapper">
            <div class="purcahseDetail-box">
                <div class="title">{{'common.' + gameData?.gameCode | translate}}
                    <div class="subtitle" *ngIf="gameData?.drawRespVOs?.length == 1">
                        <span class="date">{{gameData?.drawRespVOs[0]?.drawDateTime | date:'dd/MM/y HH:mm:ss'}}</span>
                    </div>
                </div>
                <div class="subtitle" *ngIf="gameCode != 'MiniRoulette'">
                    <div class="item-row">
                        <div class="col1">
                            <span class="lb">No. of Lines:</span><span class="num">{{userData?.panelData?.length}}</span>
                        </div>
                        <div class="col2">
                            <!-- <div class="amountWrap"><span class="lb">Bet:</span> -->
                              <!-- <span class="currency">$</span>2.5 -->
                              <!-- <span class="currency">{{userInfo?.currDisplay|currencySymbol}}</span>{{userData?.panelData[0]?.betAmountMultiple}} -->
                            <!-- </div> -->
                            <div class="amountWrap" innerHTML="{{calculateTotalPrice() | custCurrency}}"></div>
                        </div>
                        <div class="col3" (click)="removeBet()">
                            <svg class="svgicon trashIcon">
                                <use xlink:href="assets/images/sprite-sheet.svg#icon-trash"></use>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="playedRowWrap" *ngIf="gameCode !='BingoSeventyFive3'">
                    <div class="item-row" *ngFor="let panel of userData?.panelData; let pIndex = index;">
                        <div class="col1">
                            <div class="selection" *ngIf="gameCode == 'Zerotonine'">
                                <ng-container *ngIf="panel.pickType != 'Banker' && panel.pickType != 'Banker1AgainstAll' && betData[panel.betType].winMode == 'MAIN'">
                                    <!-- <div class="ballBox no-wrap">
                                        <div class="ballWrap x-auto ball-{{numberArray[panel.pickedValues]?.color}}">
                                            {{getMappedData(panel.pickedValues)}}
                                        </div>
                                    </div> -->
                                    <div class="valuebox">{{getMappedData(panel.pickedValues)}}</div>
                                </ng-container>
                            </div>
                            <div class="selection" *ngIf="gameCode == 'OneByTwelve'">
                                <div class="itemSymWrap">
                                    <div class="itemSym icon-{{iconMapping[panel.pickedValues]}}">
                                        <svg class="svgicon">
                                            <use
                                                [attr.xlink:href]="'assets/images/fortune-sprite.svg#icon-'+iconMapping[panel.pickedValues]">
                                            </use>
                                        </svg>
                                    </div>
                                    <div class="label">{{'dge.'+iconMapping[panel.pickedValues] | translate}}</div>
                                </div>
                            </div>
                            <div class="selection" *ngIf="panel.pickType != 'Banker' && panel.pickType != 'Banker1AgainstAll' && betData[panel.betType].winMode == 'MAIN' && gameCode == 'MiniRoulette'">
                                <div class="ballBox">
                                    <div class="ballWrap hollow box-{{numberArray[pickedNo]?.color}}"
                                        *ngFor="let pickedNo of panel.pickedValues; let k = index;">
                                        {{pickedNo}}
                                    </div>
                                </div>
                            </div>
                            <div class="selection" *ngIf="betData[panel.betType].winMode != 'MAIN'">
                                <div class="valuebox" *ngIf="betData[panel.betType].winMode == 'COLOR'">
                                    <div
                                        class="colorDot ball-{{betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1] | lowercase}}">
                                    </div>
                                    {{'dge.'+getSideBetPickName(betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1]) | translate}}
                                </div>
                                <div class="valuebox" *ngIf="betData[panel.betType].winMode == 'SUM' && gameCode == 'MiniRoulette'">
                                    {{betData[panel.betType].pickTypeData.pickType[panel.pickType].name.split('To')[0] + '-' + betData[panel.betType].pickTypeData.pickType[panel.pickType].name.split('To')[1]}}
                                </div>
                                <div class="valuebox" *ngIf="betData[panel.betType].winMode == 'SUM' && gameCode != 'MiniRoulette'">
                                    {{betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[0] == 0 ? '&lt; ' + betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[2] : '&gt;
                                        ' + betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[0]  | titlecase}}
                                </div>
                                <div class="valuebox" *ngIf="betData[panel.betType].winMode == 'ODD_EVEN'">
                                    {{'dge.'+getSideBetPickName(betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1]) | translate}}
                                </div>
                                <div class="valuebox" *ngIf="betData[panel.betType].winMode == 'PATTERN'">
                                    {{'dge.'+getSideBetPickName(betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue) | translate}}
                                </div>
                            </div>
                            <div class="detail small" *ngIf="gameCode != 'Zerotonine' && gameCode != 'OneByTwelve'">
                                <span>
                                    {{(betData[panel.betType].winMode == 'MAIN' ? 'dge.mainbet' : 'dge.sidebet') | translate}}
                                </span>
                                <span class="separator">:</span>
                                <span>
                                    {{'dge.'+betData[panel.betType].betDispName | translate}}
                                </span>
                                <span class="separator">-</span>
                                <span>
                                    {{'dge.'+getPickName(betData[panel.betType].pickTypeData.pickType[panel.pickType].code, betData[panel.betType].pickTypeData.pickType[panel.pickType].name, panel?.quickPick) | translate}}
                                </span>
                                <ng-container *ngIf="betData[panel.betType].winMode == 'MAIN'">
                                    <span class="separator">-</span>
                                    <span>
                                        {{numberOfLines(pIndex)}}
                                        {{(numberOfLines(pIndex) > 1 ? 'dge.lines' : 'dge.line') | translate}}
                                    </span>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col2">
                            <div class="valueWrap" *ngIf="gameCode == 'Zerotonine' || gameCode =='OneByTwelve'"><span class="value">{{panel.totalNumbers}} {{'QTY'}}</span></div>
                            <div class="valueWrap" *ngIf="gameCode != 'Zerotonine' && gameCode !='OneByTwelve'"><span class="value">{{panel.betAmountMultiple}}</span></div>
                        </div>
                        <div class="col3" (click)="removePanel(pIndex)" *ngIf="gameCode == 'MiniRoulette'">
                            <svg class="svgicon trashIcon">
                                <use xlink:href="assets/images/sprite-sheet.svg#icon-trash"></use>
                            </svg>
                        </div>            
                    </div>
                </div>
                <div class="playedCardsWrap" *ngIf="gameCode =='BingoSeventyFive3'">
                  <div class="cardWrapper {{cardClass}}">
                      <div class="cardGroup" *ngFor="let panel of userData?.panelData; let pIndex = index;">
                          <div class="cardWrap">
                              <span class="deleteIcon" (click)="removePanel(pIndex)">
                                  <svg class="svgicon trashIcon">
                                      <use xlink:href="assets/images/sprite-sheet.svg#icon-trash"></use>
                                  </svg>
                              </span>
                              <div class="card">
                                  <div class="cardTitle">
                                      <span>B</span>
                                      <span>I</span>
                                      <span>N</span>
                                      <span>G</span>
                                      <span>0</span>
                                  </div>
                                  <div class="cardNumWrap">
                                      <ul>
                                          <ng-container *ngFor="let pickedNo of panel?.pickedValues; let j = index">
                                              <li class="num" *ngFor="let second of pickedNo; let k = index"
                                                  [ngClass]="{'Free': second == 'X', 'empty': second == '_'}">
                                                  <span *ngIf="second == 'X'">
                                                      <svg class="svgicon starIcon">
                                                          <use xlink:href="assets/images/sprite-sheet.svg#icon-star">
                                                          </use>
                                                      </svg>
                                                  </span>
                                                  <span
                                                      *ngIf="second != 'X'">{{(second !=  '_' ? second : '')}}</span>
                                              </li>
                                          </ng-container>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>

        </div>
    </div>
    <div class="confirmFooter fix-bottom bg-white" *ngIf="gameCode!='BingoSeventyFive3'">
        <div class="sectionWrapper">
            <div class="drawNumSelection" *ngIf="gameData?.drawRespVOs?.length > 1">
                <div class="label">{{'dge.no_draw' | translate}}</div>
                <div class="valueSelector">
                    <div class="btnWrap btn" (click)="drawChange('-')"><span>-</span></div>
                    <div class="inputWrap">
                        <input type="text" readonly maxlength="2" [(ngModel)]="numOfDrawsSelected"
                            (keyup)="onDrawInputChange()">
                    </div>
                    <div class="btnWrap btn" (click)="drawChange('+')"><span>+</span></div>
                </div>
                <div class="separator"><span class="txt">{{'dge.or' | translate}}</span></div>
                <div class="customSelectorBtn" (click)="openAdvDrawPopup()">
                    <button>
                        <div class="iconWrap">
                            <span class="badge" *ngIf="advanceDrawCount != '0'">{{advanceDrawCount}}</span>
                            <svg class="svgicon">
                                <use xlink:href="assets/images/sprite-sheet.svg#icon-advanceddraw"></use>
                            </svg>
                        </div>
                        <div class="btnText">{{'dge.draw_list' | translate}}</div>
                    </button>
                </div>
            </div>
            <div class="powerzone">
                <div class="betInfoWrap">
                    <div class="betInfo">
                        <!-- <div class="txt">{{userData?.panelData?.length}}</div> -->
                        <div class="txt" innerHTML="{{calculateTotalCards()}}"></div>
                        <!-- <div class="label" *ngIf="gameCode!='OneByTwelve'">{{'dge.totbet' | translate}}</div> -->
                        <div class="label" *ngIf="gameCode != 'MiniRoulette'">{{'dge.selected_cards' | translate}}</div>
                        <div class="label" *ngIf="gameCode == 'MiniRoulette'">{{'dge.selected_chips' | translate}}</div>
                    </div>
                    <div class="betInfo">
                        <div class="txt" innerHTML="{{calculateTotalPrice() | custCurrency}}"></div>
                        <div class="label">{{'dge.totbetval' | translate}}</div>
                    </div>
                </div>
                <button class="buyNowBtn btn-primary" (click)="confirmTicketPurchase()">
                    {{'dge.cnfrm_buy' | translate}}
                </button>
            </div>
        </div>
    </div>
    <div class="confirmFooter fix-bottom bg-white" *ngIf="gameCode =='BingoSeventyFive3'">
      <div class="sectionWrapper">
          <div class="powerzone">
              <div class="betInfoWrap">
                  <div class="betInfo">
                      <div class="txt">{{userData?.panelData?.length}}</div>
                      <div class="label">Selected Cards</div>
                  </div>
                  <div class="betInfo">
                      <div class="txt" innerHTML="{{calculateTotalPrice() | custCurrency}}"></div>
                      <div class="label">{{'dge.totbetval' | translate}}</div>
                  </div>
              </div>
              <button class="buyNowBtn btn-primary" (click)="confirmTicketPurchase()">
                  {{'dge.cnfrm_buy' | translate}}
              </button>
          </div>
      </div>
  </div>
</div>
